<template>
    <b-form ref="form" @submit.prevent="setMaterialPost">
        <b-form-group>
            <v-select v-model="component" label="Name" :options="materials" />
        </b-form-group>

        <b-button type="submit" variant="info">Add Material</b-button>
    </b-form>
</template>

<script>
import VSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import MaterialService from "@/api-services/material.service";

export default {
    name: "AddMaterialToTask",

    // things we want to use
    components: {
        VSelect,
    },

    // data we bind to, components need a function wrapping this all up, to keep instances seperate
    data: function () {
        return {
            component: null,
            materials: [],
        };
    },

    created() {
        this.fetchMaterials();
    },

    // things we do to data
    methods: {
        setMaterialPost() {
            this.$emit("add", this.component);
        },

       fetchMaterials() {
            MaterialService.getAll().then((response) => {
                this.materials = response.data;
            });
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/partials/add-material-to-task.vue